import {
  DealPayrollAssignmentTraining, DealPayrollGrade, PayrollCalculationMethod, UserPayrollSettingsResponse
} from 'app/models/deal-payroll.model';
import {
  dealPayrollPositionKey
} from 'app/models/deal-payroll-settings.adapter';
import {dealPayrollGradeKey} from 'app/models/deal-payroll-presentation';
import {DealPayrollGradeOption} from './deal-payroll-user-settings.types';

export function enabledDealPayrollGrades(
  response: UserPayrollSettingsResponse
): DealPayrollGradeOption[] {
  return (response.grades || []).filter((grade: DealPayrollGrade) =>
    !!grade && (grade.enabled === true || grade.gradeCode === response.gradeCode)).map((grade: DealPayrollGrade) => ({
      gradeCode: grade.gradeCode,
      labelKey: dealPayrollGradeKey(grade.gradeCode)
    }));
}

export function hasDealPayrollAssignmentOptions(
  response: UserPayrollSettingsResponse
): boolean {
  return !!(response.grades || []).length;
}

export function currentDealPayrollPositionKey(
  response: UserPayrollSettingsResponse
): string {
  const positions = (response.payrollPositions || []).filter(candidate => !!candidate
    && candidate.ownerGroupId === response.positionOwnerGroupId
    && candidate.positionId === response.positionId);
  const position = positions.shift();
  return position ? dealPayrollPositionKey(position) : null;
}

export function canStartDealPayrollAssignment(response: UserPayrollSettingsResponse): boolean {
  const eligibility = response && response.assignmentEligibility;
  return !!response && (response.gradeLocked === true || !!eligibility && eligibility.canAssign);
}

export function dealPayrollProbationBlockers(response: UserPayrollSettingsResponse): string[] {
  if (response && response.gradeLocked === true) { return []; }
  const eligibility = response && response.assignmentEligibility;
  return eligibility && eligibility.blockers ? eligibility.blockers : [];
}

export function incompleteAssignmentTrainings(response: UserPayrollSettingsResponse): DealPayrollAssignmentTraining[] {
  if (response && response.gradeLocked === true) { return []; }
  const eligibility = response && response.assignmentEligibility;
  return (eligibility && eligibility.trainings || []).filter(training => training.currentLevel < training.requiredLevel);
}

export function isDealPayrollMethodSelected(
  response: UserPayrollSettingsResponse,
  method: PayrollCalculationMethod
): boolean {
  return !!response && response.payrollCalculationMethod === method;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/deal-payroll-user-settings/deal-payroll-user-settings.selectors.ts